import { Reducer } from 'redux';
import { DetailState, DetailActions, SERVICE_QUERT_POLICY_DETAIL__FETCH_POLICY_DETAIL_DONE } from './types';

const initialState: DetailState = {};

const detailReducer: Reducer<DetailState, DetailActions> = (state = initialState, action): DetailState => {
  switch (action.type) {
    // 取得保單明細 完成
    case SERVICE_QUERT_POLICY_DETAIL__FETCH_POLICY_DETAIL_DONE: {
      return { ...state, data: action.payload.response };
    }
    // Default
    default:
      return state;
  }
};

export default detailReducer;
